import React, { useEffect, useMemo } from "react";
import Lottie from "lottie-react";
import loopScribeAnimation from "assets/lotties/scribe/loopScribaAnimation.json";
import qrBox from "assets/images/qrBox.svg";
import QRCode from "qrcode.react";
import { useParams } from "react-router-dom";
import { animated } from "react-spring";
import useTextFadeSwitcher from "hooks/useTextFadeSwitcher";
import { useLayoutContext } from "layout/layout-provider";
import {useScribeContext} from "../../contexts/scribe/scribe-provider";
const qrBoxScaleBase = 2;

const QRCodeScribe: React.FC = () => {
  const [scale, setScale] = React.useState<number>(qrBoxScaleBase);
  const [qrCodeBoxPosition, setQrCodeBoxPosition] = React.useState<number>(0);
  const {switchToQrCodeScribe, setShowQrCode, showQrCode, fullName} = useScribeContext();
  const [isReadyForAnimation, setIsReadyForAnimation] = React.useState<boolean>(false); // Stato per controllare l'animazione

  //setscriba qr box scale?
    useEffect(() => {
        const scribeLoopAnimationElement = document.getElementById(
            "scribe-loop-animation"
        );

        if (scribeLoopAnimationElement) {
            const rect = scribeLoopAnimationElement.getBoundingClientRect();
            setScale(() => rect.width / 800 * qrBoxScaleBase);
            setQrCodeBoxPosition(() => rect.height + 15);
        }
    }, [ switchToQrCodeScribe, setScale, setQrCodeBoxPosition]);

    useEffect(() => {
        // Delay animation readiness to ensure transitions are applied
        const timerId = setTimeout(() => {
            setIsReadyForAnimation(true);
        }, 50); // Ritardo breve per attivare la transizione
        return () => clearTimeout(timerId);
    }, []);

    const currentURL = useMemo(
    () => `https://nomeingeroglifico.museoegizio.it/result/${fullName}`,
    [fullName],
  );

  /*
   const currentURL = useMemo(
    () => `${window.location.origin}/result/${fullName}`,
    [fullName],
  );*/

  //Custom hook to manage fading text switching
  const {
    text: textTitle,
    fadeProps: fadePropsTitle,
    textStyle: titleStyle,
  } = useTextFadeSwitcher(
    "INQUADRA IL QR CODE",
    "SCAN THE QR CODE",
    3000,
    "25px",
      "1.1",       // Interlinea
      "#FFffff"
  );
  const {
    text: textSub,
    fadeProps: fadePropsSub,
    textStyle: subStyle,
  } = useTextFadeSwitcher(
    "SCARICA IL CONTENUTO",
    "DOWNLOAD THE CONTENT",
    3000,
    "18px",
      "0.5",       // Interlinea
      "#AD8B19"
  );

    // Show QR Code after a delay
    useEffect(() => {
        if (showQrCode) return;

        const timerId = setTimeout(() => {
            setShowQrCode(true);
        }, 2000);

        return () => clearTimeout(timerId);
    }, [showQrCode, setShowQrCode]);

  //set qr code box position...
  useEffect(() => {
    const scribeLoopAnimationElement = document.getElementById(
      "scribe-loop-animation",
    );

    if (!scribeLoopAnimationElement) {
      return;
    }

    const bottom =
      scribeLoopAnimationElement.getBoundingClientRect().height + 15;

    setQrCodeBoxPosition(bottom);
  }, []);

  return (
      <>
        {switchToQrCodeScribe && (<>
          <div className="relative height-100">
            {scale !== null  && (
                <div
                    className="flex justify-center align-center"
                    style={{
                        transform: showQrCode
                            ? `scale(${scale}) translateY(0)`
                            : `scale(${scale}) translateY(50px)`,
                        transition: "transform 1s ease,  opacity 0.5s ease",
                        opacity: showQrCode ? "1" : "0",
                        bottom: `${qrCodeBoxPosition}px`,
                        position: "absolute",
                        marginLeft: "20px",
                        marginBottom:"-30px"
                    }}
                >
                  <img
                      src={qrBox}
                      alt="error loading page. please refresh!"
                      className={
                        window.innerWidth > 1140 && window.innerWidth < 1635
                            ? "origin-bottom"
                            : window.innerWidth <= 1140
                                ? "origin-bottom-left"
                                : "origin-bottom-right"
                      }

                  />
                  <div className="absolute top-0 left-0  right-0 flex direction-column align-center ">
                    <QRCode
                        value={currentURL}
                        className="scale-qr"
                        style={{ marginTop: "45px" }}
                        level="H"
                    />
                    <div
                        className="flex direction-column justify-center align-center gap-10"
                        style={{ paddingRight: "10px", marginTop: "25px"}}
                    >
                      <animated.div
                          style={{
                            ...fadePropsTitle,
                            ...titleStyle,
                              textAlign: "center",
                              //color: "#ad8b19",
                              color: "white",
                              fontWeight: "bold",
                          }}
                          className={"qr-code-text"}

                      >
                        {textTitle}
                      </animated.div>
                      <animated.div
                          style={{
                            ...fadePropsSub,
                            ...subStyle,
                              textAlign: "center",

                          }}
                          className={"qr-code-text"}
                      >
                        {textSub}
                      </animated.div>
                    </div>
                  </div>
                </div>
            )}

            <Lottie
                animationData={loopScribeAnimation}
                autoplay={true}
                loop={true}
                id="scribe-loop-animation"
                className="lottie-animation absolute bottom-0 right-0"
                style={{
                    transition: isReadyForAnimation
                        ? "transform 3s ease, opacity 2s ease"
                        : "none", // Nessuna transizione iniziale
                    opacity: showQrCode ? "1" : "0",
                    transform: showQrCode
                        ? "translateY(0)"
                        : "translateY(70px)",

                }}
            />
          </div>
        </>)}
      </>
  );
};

export default QRCodeScribe;

/* <div>Inquadra il QR Code e scarica il contenuto</div>
              <div>Frame the QR code and download the content</div>*/

/*
transition: "opacity 1s ease-in-out",
                  opacity: showQrCode ? undefined : "0",*/
